import { render } from "./App.vue?vue&type=template&id=44209e0b&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=44209e0b&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=44209e0b&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44209e0b"]])

export default __exports__